import { ADD_DECK, SET_CARDS, TOGGLE_LOADING, SET_ERROR } from './actionType';

export const fetchCard = () => {
  return async (dispatch, getState) => {
    const { search: {urlFetch} } = getState()

    try {
      dispatch(toggleLoading())
      const res = await fetch(urlFetch)
      if (res.ok) {
        const result = await res.json()
        dispatch(setCards(result.data))
      } else {
        if (res.status === 400) {
          const someErr = await res.json()
          console.log(someErr);
          throw Error('Card not found')
        }
        throw Error('Something went wrong')
      }
    } catch (err) {
      dispatch(setError(err))
      return Promise.reject(err)
    } finally {
      dispatch(toggleLoading())
    }
  }
}

export const actAddDeck = (payload) => {
  const actionAddDeck = {
    type: ADD_DECK,
    payload
  }
  return actionAddDeck
}

export const setCards = (payload) => {
  return {
    type: SET_CARDS,
    payload
  }
}

export const toggleLoading = () => {
  return {
    type: TOGGLE_LOADING
  }
}

export const setError = (payload) => {
  return {
    type: SET_ERROR,
    payload
  }
}
